<template>
	<GetInTouchButton @on-click="handleModal(true)" />

	<GetInTouchDialogModal :show="showModal" @close="handleModal(false)" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import GetInTouchButton from '@/Components/ui/GetInTouchButton.vue'
import GetInTouchDialogModal from '@/Components/GetInTouchDialogModal.vue'
import { useGetInTouch } from '@/Stores/getintouch'

const getInTouchStore = useGetInTouch()

const showModal = computed(() => getInTouchStore.getShowModal)

const handleModal = (status: boolean) => {
	getInTouchStore.showModal = status

	if (status === true) {
		getInTouchStore.resetStates()
	}
}
</script>
